import { render, staticRenderFns } from "./FormErrorComponent.vue?vue&type=template&id=c964a47a&scoped=true"
import script from "./FormErrorComponent.vue?vue&type=script&lang=js"
export * from "./FormErrorComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c964a47a",
  null
  
)

export default component.exports